export type Volume = {
  number: number;
  title: string;
  headline: string;
  list: string[];
  flow: string[];
};

export const volumes: Volume[] = [
  {
    number: 1,
    title: 'Introducción a la Construcción, Materiales y Sistemas Constructivos',
    headline: 'La base para comprender cómo se organiza y ejecuta una construcción.',
    list: [
      'etapas de una obra',
      'organización general',
      'materiales tradicionales y actuales',
      'propiedades de los materiales',
      'criterios generales de selección',
      'sistemas constructivos',
      'herramientas y equipos',
      'almacenamiento',
      'manipulación',
      'introducción al control de calidad',
    ],
    flow: ['Conocer', 'Organizar', 'Comparar', 'Interpretar'],
  },
  {
    number: 2,
    title: 'Dibujo Técnico, Planos y Documentación de Obra',
    headline: 'Aprendé a interpretar la información gráfica antes de construir.',
    list: [
      'simbología',
      'escalas',
      'plantas',
      'cortes',
      'vistas',
      'cotas',
      'planos arquitectónicos',
      'planos estructurales',
      'planos de instalaciones',
      'detalles constructivos',
      'lectura coordinada de documentación',
      'detección de inconsistencias básicas',
    ],
    flow: ['Observar', 'Leer', 'Interpretar', 'Relacionar'],
  },
  {
    number: 3,
    title: 'Suelos, Replanteo y Fundaciones',
    headline: 'Del terreno al soporte de la construcción.',
    list: [
      'conceptos básicos de suelo',
      'reconocimiento del terreno',
      'nivelación',
      'ejes',
      'replanteo',
      'excavaciones',
      'fundaciones superficiales',
      'zapatas',
      'plateas',
      'vigas de fundación',
      'criterios generales de selección',
      'errores frecuentes',
    ],
    flow: ['Reconocer', 'Replantear', 'Controlar', 'Fundar'],
  },
  {
    number: 4,
    title: 'Mampostería, Muros y Cerramientos',
    headline: 'Cómo se ejecutan y controlan los principales cerramientos de una obra.',
    list: [
      'mampostería',
      'ladrillos',
      'bloques',
      'morteros',
      'aparejos',
      'nivelación',
      'aplomado',
      'encuentros',
      'vanos',
      'dinteles',
      'tabiques',
      'aislaciones',
      'errores frecuentes de ejecución',
    ],
    flow: ['Ejecutar', 'Alinear', 'Controlar', 'Relacionar'],
  },
  {
    number: 5,
    title: 'Hormigón Armado y Sistemas Estructurales',
    headline: 'Comprendé cómo trabajan los principales elementos que sostienen una construcción.',
    list: [
      'conceptos estructurales esenciales',
      'cargas',
      'esfuerzos',
      'hormigón',
      'acero',
      'armaduras',
      'columnas',
      'vigas',
      'losas',
      'encofrados',
      'preparación',
      'hormigonado',
      'curado',
      'controles básicos',
      'fallas frecuentes',
    ],
    flow: ['Comprender', 'Preparar', 'Ejecutar', 'Controlar'],
  },
  {
    number: 6,
    title: 'Cubiertas, Techos e Impermeabilización',
    headline: 'Aprendé cómo se protege una construcción frente al agua y las condiciones exteriores.',
    list: [
      'cubiertas planas',
      'cubiertas inclinadas',
      'pendientes',
      'estructuras de cubierta',
      'aislaciones',
      'impermeabilización',
      'zinguería',
      'desagües pluviales',
      'encuentros',
      'sellados',
      'filtraciones',
      'errores frecuentes',
    ],
    flow: ['Proteger', 'Aislar', 'Evacuar', 'Prevenir'],
  },
  {
    number: 7,
    title: 'Instalaciones Sanitarias, Eléctricas y de Servicio',
    headline: 'Comprendé cómo se integran las principales instalaciones dentro del proyecto constructivo.',
    list: [
      'agua fría y caliente',
      'desagües',
      'ventilaciones',
      'conceptos eléctricos',
      'canalizaciones',
      'circuitos',
      'tableros a nivel introductorio',
      'instalaciones complementarias',
      'lectura de planos',
      'coordinación entre especialidades',
      'interferencias comunes',
    ],
    flow: ['Interpretar', 'Coordinar', 'Integrar', 'Verificar'],
  },
  {
    number: 8,
    title: 'Terminaciones, Revestimientos y Carpinterías',
    headline: 'La etapa que transforma la obra gruesa en un espacio terminado.',
    list: [
      'revoques',
      'revestimientos',
      'pisos',
      'cielorrasos',
      'pinturas',
      'selladores',
      'carpinterías',
      'puertas',
      'ventanas',
      'juntas',
      'terminaciones interiores y exteriores',
      'patologías frecuentes de terminación',
    ],
    flow: ['Terminar', 'Proteger', 'Controlar', 'Detectar'],
  },
  {
    number: 9,
    title: 'Seguridad, Organización y Control de Obra',
    headline: 'Cómo enseñar la obra desde una mirada preventiva, organizada y profesional.',
    list: [
      'identificación de peligros',
      'EPP',
      'orden y limpieza',
      'circulación',
      'herramientas',
      'trabajo en altura',
      'señalización',
      'almacenamiento',
      'planificación de tareas',
      'coordinación de equipos',
      'controles',
      'documentación',
      'buenas prácticas generales',
    ],
    flow: ['Identificar', 'Prevenir', 'Organizar', 'Controlar'],
  },
  {
    number: 10,
    title: 'Cómputo, Presupuesto, Planificación y Proyecto Integrador',
    headline: 'Convertí todos los contenidos anteriores en una visión completa del proceso constructivo.',
    list: [
      'lectura de documentación para cómputo',
      'medición de cantidades',
      'materiales',
      'mano de obra',
      'costos directos',
      'presupuesto básico',
      'planificación',
      'secuencia de tareas',
      'cronograma',
      'control de avance',
      'proyecto integrador',
      'análisis técnico global',
    ],
    flow: ['Medir', 'Presupuestar', 'Planificar', 'Integrar'],
  },
];
